import { handleSpecialCaseDetailArrays } from 'utils/tinyMCE/handleSpecialCaseDetailArrays'
import { tableTemplate } from '.'
import startCase from 'lodash/startCase'
import { insertTemplate } from '../insertMenu/insertTemplate'

export const handleArray = (
  editor,
  caseDetails,
  key,
  templates,
  dateFormat,
  selectedTheme,
) => {
  // Pushes content of array as a table

  const items = handleSpecialCaseDetailArrays({
    path: key,
    items: caseDetails[key],
  })

  const tableContent = tableTemplate({
    path: key,
    items,
    selectedTheme,
    editor,
  })

  templates.push({
    type: 'menuitem',
    text: `${startCase(key)}`,
    onAction: () => insertTemplate(editor, tableContent),
  })
}

export default handleArray
